import {
    BillFilters,
    BillFiltersSchema,
} from "@common/contracts/bill.contract";
import { omit } from "@common/helpers/objects";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "../useWorkspaceUserCache";

const BILL_SESSION_FILTER_KEYS = [
    "ids",
    "search",
    "hasOpenAmount",
] as const satisfies ReadonlyArray<keyof BillFilters>;

const sanitizeFilters = (
    filters: BillFilters | undefined,
): BillFilters | undefined => {
    if (!filters) {
        return undefined;
    }

    return omit(filters, [...BILL_SESSION_FILTER_KEYS]);
};

export function useBillsPageFiltersCache(): [
    BillFilters | undefined,
    (value: BillFilters | undefined) => void,
] {
    const [value, setter] = useWorkspaceUserCache<BillFilters>(
        WORKSPACE_USER_CACHE_KEYS.BILLS_PAGE_FILTERS_CACHE_KEY,
        BillFiltersSchema,
    );

    return [
        value,
        (filters: BillFilters | undefined) => {
            setter(sanitizeFilters(filters));
        },
    ];
}
